"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBot = isBot;
exports.makeCancelable = makeCancelable;
exports.getElementInnerDimensions = getElementInnerDimensions;
exports.getImageDataBySize = getImageDataBySize;
exports.getQueryParamValue = getQueryParamValue;
exports.buildImgSrcUrl = buildImgSrcUrl;
exports.keyPressHandler = keyPressHandler;
exports.clampNumber = clampNumber;
exports.regularNumber = regularNumber;
exports.addCurrentUrlToNextQueryParam = addCurrentUrlToNextQueryParam;
exports.executeWaitThenRedirect = exports.getImageByFormat = exports.checkEventListenerOptionsObjectSupport = exports.createExternalUrl = exports.getLinkWithCurrentQueryParams = exports.closeFullscreen = exports.openFullscreen = exports.mobileDevice = void 0;

function isBot() {
  /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
} // Copied from https://github.com/facebook/react/issues/5465#issuecomment-157888325


function makeCancelable(promise) {
  var hasCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    /* eslint-disable prefer-promise-reject-errors */
    promise.then(function (val) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled = true;
    }
  };
}

function getElementInnerDimensions(element) {
  var computedStyle = window.getComputedStyle(element);
  var computedPadding = {};
  ['Top', 'Bottom', 'Left', 'Right'].forEach(function (side) {
    var padding = computedStyle["padding".concat(side)];
    var cleanPadding = padding.replace(/(px|rem|em)/i, '');
    computedPadding[side.toLowerCase()] = parseInt(cleanPadding, 10) || 0;
  });
  var horizontalPadding = computedPadding.left + computedPadding.right;
  var innerWidth = element.clientWidth - horizontalPadding;
  var verticalPadding = computedPadding.top + computedPadding.bottom;
  var innerHeight = element.clientHeight - verticalPadding;
  return {
    innerHeight: innerHeight,
    innerWidth: innerWidth
  };
}

function getImageDataBySize(images, size) {
  if (!images || images.length === 0) return null;
  var image = images.find(function (imageData) {
    return (imageData.get ? imageData.get('size') : imageData.size) === size;
  });
  return image || images[0];
}

function getQueryParamValue(name, overrideParams) {
  var queryParam = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'); // eslint-disable-line

  var regex = new RegExp('[\\?&]' + queryParam + '=([^&#]*)'); // eslint-disable-line

  var results = regex.exec(overrideParams || window.location.search);
  return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function buildImgSrcUrl(imgUrl) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : process.env.REACT_APP_MAIN_500PX_URL;
  if (!imgUrl) return null; // If it starts with // (such as: //assetcdn.500px.org), it's already a complete link

  if (imgUrl.match(/^\/\//gi)) return imgUrl; // If it starts with http(s), it's already a complete link

  if (imgUrl.match(/^https?/gi)) return imgUrl; // If it starts with a slash, it's likely pointing to a local asset

  if (imgUrl.match(/^\//i)) return "".concat(baseUrl).concat(imgUrl);
  return "".concat(baseUrl, "/").concat(imgUrl);
}

function keyPressHandler(handler) {
  return function (event) {
    if (event.key === 'Enter') {
      handler();
    }
  };
} // eslint-disable-next-line consistent-return


function clampNumber(n, intlFormat) {
  var number = Math.abs(n);
  if (number === 0 || !number) return '0';
  if (number < 1000) return String(number);

  if (number < 1000000) {
    return "".concat(intlFormat(number / 1000, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }), "K");
  }

  if (number < 1000000000) {
    return "".concat(intlFormat(number / 1000000, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }), "M");
  }

  if (number >= 1000000000) {
    return "".concat(intlFormat(number / 1000000000, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }), "G");
  }
}

function regularNumber(n, intlFormat) {
  var number = n.toFixed(1);
  if (!intlFormat) return number;
  return intlFormat(number, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
}

var mobileDevice = function mobileDevice() {
  var toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  return toMatch.some(function (toMatchItem) {
    return navigator.userAgent.match(toMatchItem);
  });
};

exports.mobileDevice = mobileDevice;

var openFullscreen = function openFullscreen() {
  var elem = document.documentElement;

  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) {
    /* Firefox */
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) {
    /* Chrome, Safari and Opera */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) {
    /* IE/Edge */
    elem.msRequestFullscreen();
  }
};

exports.openFullscreen = openFullscreen;

var closeFullscreen = function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    /* Firefox */
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    /* Chrome, Safari and Opera */
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    /* IE/Edge */
    document.msExitFullscreen();
  }
};

exports.closeFullscreen = closeFullscreen;

var getLinkWithCurrentQueryParams = function getLinkWithCurrentQueryParams(link, extraParams, dropParams, overrideParams) {
  if (!link) return ''; // window.location.search come with ? when params are present

  var queryParams = overrideParams || window.location.search; // append extraParams when provided

  if (extraParams) {
    if (queryParams) {
      queryParams += "&".concat(extraParams);
    } else {
      queryParams = "?".concat(extraParams);
    }
  } // create search params for deletion


  var searchParams = new URLSearchParams(queryParams); // check all params that need to be dropped and remove them

  if (queryParams && dropParams) {
    dropParams.forEach(function (param) {
      searchParams["delete"](param);
    });
  } // add trailing question mark only if there are query params present


  var queryString = searchParams.toString() === '' ? '' : "?".concat(searchParams.toString());
  return "".concat(link).concat(queryString);
};

exports.getLinkWithCurrentQueryParams = getLinkWithCurrentQueryParams;

function addCurrentUrlToNextQueryParam(to, location) {
  if (location.pathname === '/' || location.pathname === to) {
    return getLinkWithCurrentQueryParams(to);
  }

  var extraParams = "r=".concat(location.pathname);
  return getLinkWithCurrentQueryParams(to, extraParams);
}

var createExternalUrl = function createExternalUrl(websiteUrl, isSecureSite) {
  if (websiteUrl.startsWith('http://') || websiteUrl.startsWith('https://')) {
    return websiteUrl;
  }

  return isSecureSite ? "https://".concat(websiteUrl) : "http://".concat(websiteUrl);
}; // required to make sure the browser supports addEventListener third param === object
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support


exports.createExternalUrl = createExternalUrl;

var checkEventListenerOptionsObjectSupport = function checkEventListenerOptionsObjectSupport() {
  var passiveSupported = false;

  try {
    var options = {
      get passive() {
        passiveSupported = true;
        return false;
      }

    };
    window.addEventListener('test', null, options);
    window.removeEventListener('test', null, options);
  } catch (err) {
    passiveSupported = false;
  }

  return passiveSupported;
};

exports.checkEventListenerOptionsObjectSupport = checkEventListenerOptionsObjectSupport;

var getImageByFormat = function getImageByFormat(image) {
  var webpSupported = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!image) return null;

  if (webpSupported && image !== null && image !== void 0 && image.webpUrl) {
    return image.webpUrl;
  }

  return (image === null || image === void 0 ? void 0 : image.jpegUrl) || (image === null || image === void 0 ? void 0 : image.url);
};

exports.getImageByFormat = getImageByFormat;

var executeWaitThenRedirect = function executeWaitThenRedirect(func, to) {
  var wait = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 600;
  func(); // Note: need a wrapper because an evaluated redirect function will fire immediately

  setTimeout(function () {
    window.location.assign(to);
  }, wait);
};

exports.executeWaitThenRedirect = executeWaitThenRedirect;